"use client";

import type { FC, Ref } from "react";
import { useTranslation } from "react-i18next";
import type { AnalysisHeadingTemplateProps } from "../AnalysisHeadingTemplate";
import { AnalysisHeading } from "@huub-web/shared";

export interface BidStrategyHeadingTemplateProps
  extends AnalysisHeadingTemplateProps {}

/**
 * @deprecated
 */
export const BidStrategyHeadingTemplate: FC<
  BidStrategyHeadingTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ generatedAt, title, description, ref }) => {
  const { t } = useTranslation();

  return (
    <AnalysisHeading
      ref={ref}
      generatedAt={generatedAt}
      title={title ?? t("bidStrategyHeading.title")}
      description={description ?? t("bidStrategyHeading.description")}
    />
  );
};
